@if (!processing) {
  <div class="card mt-1">
    <div class="card-body">
      <div class="row">
        <div class="col-9"><h4>Audit</h4></div>
        <div class="col-3">
          <div class="text-end">
            @if (!displayForm && capture.userAuditOutcome && canEdit) {
              <a href="javascript:;" (click)="onEdit($event)"><fa-icon [icon]="['fas', 'pen']" /></a>
            }
          </div>
        </div>
      </div>
      @if (displayForm) {
        <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
          @if (serverErrorMessage) {
            <div class="alert-danger text-danger p-1 mb-2">
              An error occurred while saving this audit: {{ serverErrorMessage }}
            </div>
          }
          <div class="row align-items-end">
            <div class="col-6">
              <label>Audit Outcome</label>
              <ng-select
                placeholder="-- Select Outcome --"
                bindValue="value"
                bindLabel="display"
                [items]="availableOutcomes"
                formControlName="status" />
            </div>
            <div class="col-6">
              <button class="btn btn-primary" type="submit" [disabled]="!allowSubmit">
                Save Outcome
              </button>
              @if (capture.userAuditOutcome) {
                <button class="btn btn-secondary" (click)="onCancel($event)">Cancel</button>
              }
            </div>
          </div>

          @if (isNonCompliant) {
            <div class="row mt-3">
              <div class="col-6">
                <label>Select Outcome Reason(s)</label>
                  @for (reason of availableOutcomeStatusReasons; track reason.value; let i = $index) {
                    <div>
                    <input type="checkbox" id="reason-{{i}}" [formControlName]="reason.value">
                    <label for="reason-{{i}}">{{ reason.display }}</label>
                    </div>
                  }
              </div>
            </div>
          }

          <div class="row mt-3">
            <div class="col-8">
              <label>
                Audit Note
                @if (isNonCompliant) {
                  <span>
                    (Required)
                  </span>
                }
              </label>
              <textarea formControlName="note" name="note" class="form-control w-50"></textarea>
            </div>
          </div>
        </form>
      } @else {
        @if (capture.userAuditOutcome) {
          <strong>Audit Outcome</strong>
          <p>
            {{ capture.userAuditOutcome.status | captureUserAuditOutcomeStatus }}
          </p>
          @if (capture.userAuditOutcome.statusReasons && capture.userAuditOutcome.statusReasons.length > 0 ) {
            <div>
              <strong>Reasons</strong>
              <p>
                {{ capture.userAuditOutcome.statusReasons | captureUserAuditOutcomeStatusReasons }}
              </p>
            </div>
          }
          @if (capture.userAuditOutcome.note) {
            <div>
              <strong>Audit Note</strong>
              <p>
                {{ capture.userAuditOutcome.note }}
              </p>
            </div>
          }
          <div class="row">
            <div class="col-2">
              <strong>Audited By</strong>
              <div>
                {{ capture.userAuditOutcome.auditingUser.email }}
              </div>
            </div>
            <div class="col-2">
              <strong>Audited On</strong>
              <div>
                {{ capture.userAuditOutcome.lastUpdatedAt | date: 'MM/dd/yyyy' }}
              </div>
            </div>
          </div>
        } @else {
          <div class="row">
            <div class="col-12">Capture has not been audited.</div>
          </div>
        }
      }
    </div>
  </div>
} @else {
  <div class="py-2">
    <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
    Saving audit...
  </div>
}



